/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Locked_Loans_DescriptionInputs */



/**
* | output |
* | --- |
* | "Keep track of cards you lend to friends: who has them, and what you're borrowing back." |
*
* @param {Nav_Locked_Loans_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_locked_loans_description = /** @type {((inputs?: Nav_Locked_Loans_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Locked_Loans_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Behalte den Überblick über Karten, die du verleihst: wer sie hat und was du selbst geliehen hast.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gardez trace des cartes que vous prêtez : qui les a, et ce que vous empruntez.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("记录你借给朋友的卡：在谁手上，以及你借来了什么。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("追蹤你借給朋友的卡：誰拿著，以及你向別人借了什麼。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("친구에게 빌려준 카드를 누가 가지고 있는지, 빌려온 카드는 무엇인지 관리하세요.")
	return /** @type {LocalizedString} */ ("Keep track of cards you lend to friends: who has them, and what you're borrowing back.")
});